type WithRequired<T, K extends keyof T> = T & Required<Pick<T, K>>

export type ApiError = Base.Api.Error;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApiError = (resp: any): resp is ApiError => {
  return resp && typeof ((resp as ApiError).error) === "string"
}

// Before a question's countdown has started, we only know its text/image - config is
// still undefined, so none of these guards match yet (which is correct: we don't know
// the type either).

export const isMultipleChoiceQuestion = (question?: Quiz.Api.Question): question is WithRequired<Quiz.Api.MultipleChoiceQuestion, "config"> => {
  return question?.config?.type === "multiple_choice"
}

export const isSliderQuestion = (question?: Quiz.Api.Question): question is WithRequired<Quiz.Api.SliderQuestion, "config"> => {
  return question?.config?.type === "slider"
}

export const isMultiSelectQuestion = (question?: Quiz.Api.Question): question is WithRequired<Quiz.Api.MultiSelectQuestion, "config"> => {
  return question?.config?.type === "multi_select"
}

export const isMatchPairsQuestion = (question?: Quiz.Api.Question): question is WithRequired<Quiz.Api.MatchPairsQuestion, "config"> => {
  return question?.config?.type === "match_pairs"
}
